import { createContext } from 'react';

const TripContext = createContext({ trips: [] });

export default TripContext;
